import { Link } from 'react-router-dom';
import { articlePreviews } from '@/mocks/articles';

export default function ArticlePreviewGrid() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-semibold text-foreground-950 mb-3">
            Artykuły i poradniki Kakobuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Przeczytaj nasze artykuły, aby dowiedzieć się więcej o Kakobuy Spreadsheet, bezpieczeństwie zakupów i najlepszych produktach.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articlePreviews.map((article) => (
            <Link
              key={article.slug}
              to={`/artykul/${article.slug}`}
              className="group flex flex-col bg-background-100/60 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 hover:shadow-sm transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full h-40 md:h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-0.5 bg-background-50/90 text-foreground-950 text-xs font-medium rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3 flex-1">
                  {article.description}
                </p>
                <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-500">
                  Czytaj więcej
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}